import { atom } from "jotai";

export type WindowCloseRequest = {
  windowId: string;
  requestId: number;
};

const windowCloseRequestStateAtom = atom<WindowCloseRequest | null>(null);

const requestCloseWindowAtom = atom(
  (get) => get(windowCloseRequestStateAtom),
  (get, set, windowId: string) => {
    const currentRequest = get(windowCloseRequestStateAtom);

    set(windowCloseRequestStateAtom, {
      windowId,
      requestId: (currentRequest?.requestId ?? 0) + 1,
    });
  },
);

export default requestCloseWindowAtom;
